function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.125 4.37542H3.25238L10.2183 1.72155C10.4449 1.6358 10.5577 1.38292 10.4711 1.1563C10.3854 0.929673 10.1325 0.816798 9.90675 0.903423L0.71925 4.40342C0.716625 4.40517 0.714875 4.40692 0.71225 4.40867C0.310625 4.48742 0 4.82605 0 5.25042V12.2504C0 12.7334 0.392875 13.1254 0.875 13.1254H13.125C13.608 13.1254 14 12.7334 14 12.2504V5.25042C14 4.7683 13.608 4.37542 13.125 4.37542ZM4.375 11.3754C2.92775 11.3754 1.75 10.1977 1.75 8.75042C1.75 7.30317 2.92775 6.12542 4.375 6.12542C5.82225 6.12542 7 7.30317 7 8.75042C7 10.1977 5.82225 11.3754 4.375 11.3754ZM12.25 11.3754H8.75V10.5004H12.25V11.3754ZM12.25 9.62542H8.75V8.75042H12.25V9.62542ZM12.25 7.87542H8.75V7.00042H12.25V7.87542Z"
});

var SvgRadioIcon = function SvgRadioIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRadioIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/radio-icon.4ba761c4.svg";
export { ForwardRef as ReactComponent };